module.exports = __webpack_public_path__ + "media/application/images/2022/online-c6bb2753e4ee8134343feb76f1b81ac8.png";